import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: 'ca366688-31d6-4e23-8cf7-c3078d99dc86', // Replace with your Azure AD app's client ID
    authority: 'https://login.microsoftonline.com/5792d09f-af5f-4f89-8019-ec25ecf3369e', // Replace with your tenant ID
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage', // You can also use localStorage
    storeAuthStateInCookie: true, // Recommended false unless you need it for IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
  
};

export const loginRequest = {
  scopes: ["User.Read", "profile", "email", "openid"]
};
